module.exports = __webpack_public_path__ + "static/media/consumables_img.84544ec0.jpg";